export default __webpack_public_path__ + "static/media/appp.e3ae3631.png";